<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" i18n>Einkäufe</h1>

    <div class="mt-3">
      <app-order-search (searchCriteria)="search($event)"></app-order-search>
    </div>

    @for (orderGroup of orderGroups; track orderGroup) {
      <app-order-group-list-item [orderGroup]="orderGroup"></app-order-group-list-item>
    }

    @if (orderGroups) {
      <p class="text-muted mt-3" i18n="@@pagedList.countOfTotal">{{ orderGroups.length }} von {{ totalCount }} Einträgen</p>
    }
    @if (orderGroups && orderGroups.length < totalCount) {
      <button class="btn btn-outline-primary" type="button" (click)="loadMore()" [disabled]="loadingMore" i18n="@@pagedList.loadMore">
        @if (loadingMore) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Mehr laden
      </button>
    }

  </div>
</div>